module.exports = __webpack_public_path__ + "img/icn_done.c0668754.svg";